/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_TOPICS } from "../graphql";
import { VApplication } from "../../../application";

import { AppNavigatorService } from "../../appNavigatorService";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import toast from "react-hot-toast";

const log: any = LoggerModule?.getInstance();
const getWhoamiSrv = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetTopicsMethods extends IPluginMethodMap {
  getTopics(args: any): Promise<any>;
}

export class GetTopicsService implements IAgentPlugin {
  readonly methods: IGetTopicsMethods;

  constructor() {
    this.methods = {
      getTopics: this.getTopics.bind(this),
    };
  }

  async getTopics(args: any) {
    log.info(`getTopics in service`, args);
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_TOPICS,
          variables: {
            distCentFilter: {
              _id: args?.payload?.distCenter,
            },
            queueType: "distribution",
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          console.log(`bands data`, res.data);
          return {
            topics: this.formatTopics(res?.data?.getMQTTSubString),
          };
        }
      }
    } catch (err: any) {
      toast.error(err?.message);
      throw err;
    }
    // return {...(config || {})}
  }

  private formatTopics(paymentq: any) {
    log.info(`formatTopics`, paymentq);
    const topics = [];
    if (paymentq && paymentq?.subString) {
      topics.push(paymentq?.subString);
    }

    log.info(`topics in formatTopics`, topics);
    return topics;
  }
}
